<template>
  <v-dialog v-model="dialogShow" persistent width="640"  class="dialog">
    <v-card>
      <v-card-title class="dialogTitle">
        <p class="dialogTitle-title">新建文件</p>
        <v-spacer></v-spacer>
        <p @click="closeDialog" class="dialogTitle-close iconfontFamily">&#xe60d;</p>
      </v-card-title>
      <v-card-text style="padding:41px 27px 30px 27px;">
        <!--选择文件类型-->
        <div style="display:flex;margin-left: 16px">
          <v-radio-group
                  v-model="folderTypeSelect"
                  row
          >
            <v-radio
                    color="rgba(42, 130, 228, 1)"
                    :value="0"
            >
              <template v-slot:label>
                <div :style="{'color':folderTypeSelect === 0 ? '#000000':'#a6a6a6'}">个人文件</div>
              </template>
            </v-radio>
            <v-radio
                    color="rgba(42, 130, 228, 1)"
                   :value="1"
                    style="margin-left: 170px"
            >
              <template v-slot:label>
                <div style="display: flex;align-items: center">
                  <div :style="{'color':folderTypeSelect === 1 ? '#000000':'#a6a6a6'}">团队文件</div>
                  <span class="iconfontFamily" style="color: rgba(255, 0, 0, 1);font-size: 28px;margin-left: 6px;">&#xe686;</span>
                </div>

              </template>
            </v-radio>
          </v-radio-group>
        </div>

        <!--文件名填写-->
        <div style="display:flex;align-items:center;margin-top: 20px;margin-left: 16px">
          <p style="font-size:16px;color:#000000;">文件名</p>
          <div style="width: 460px;margin-left:46px;">
            <v-text-field v-model="folderName" placeholder="请输入文件名" dense outlined hide-details width="460" height="36" ></v-text-field>
          </div>
        </div>
        <p :style="{'visibility':errorShow ? 'visible' : 'hidden'}" style="margin-left:109px;margin-top:5px;font-size:14px;color:#ff0000;"><span class="iconfontFamily">&#xe71f;</span>{{errorText}}</p>
        <!--个人文件填写-->
        <div v-if="folderTypeSelect === 0">
          <div style="margin-top:49px;text-align:right;">
            <v-btn @click="createFolder" width="100" height="33" dark color="#1E3A8A">新建</v-btn>
          </div>
        </div>
        <!--团队文件填写-->
        <div v-else style="align-items:center;margin-top: 20px;">
          <div style="width: 586px;height: 1px;background: rgba(229, 229, 229, 1)"></div>
          <div style="margin-left: 16px;display: flex">
            <div style="width: 200px">
              <v-radio-group
                      v-model="teamFileSelect"
                      column
              >
                <v-radio
                        color="rgba(42, 130, 228, 1)"
                        :value="0"
                >
                  <template v-slot:label>
                    <div :style="{'color':teamFileSelect === 0 ? '#000000':'#a6a6a6'}" style="margin-left: 5px">团队文件中数据可新增</div>
                  </template>
                </v-radio>
                <v-radio
                        color="rgba(42, 130, 228, 1)"
                        :value="1"
                >
                  <template v-slot:label>
                    <div style="display: flex;align-items: center">
                      <div :style="{'color':teamFileSelect === 1 ? '#000000':'#a6a6a6'}" style="margin-left: 5px">团队文件只读</div>
                    </div>
                  </template>
                </v-radio>
              </v-radio-group>
            </div>
            <div style="margin-top: 20px;margin-left: 60px;font-size: 14px">
              <div :style="{'color':teamFileSelect === 0 ? '#000000':'#a6a6a6'}" style="margin-bottom: 8px;line-height: 24px">可新增数据，同时可编辑、删除本人创建的数据</div>
              <div :style="{'color':teamFileSelect === 1 ? '#000000':'#a6a6a6'}" style="line-height: 24px">团队文件中所有的数据都不能由协作者进行编辑</div>
            </div>
          </div>
          <div style="width: 586px;height: 1px;background: rgba(229, 229, 229, 1)"></div>
          <div style="margin-left: 16px;display: flex;margin-top: 12px;">
            <v-checkbox
                    v-model="allowMembersExportFiles"
                    color="#297aff"
                    hide-details
                    dense
            >
              <template v-slot:label>
                <div style="color: black;margin-left: 5px">允许团队文件协作者导出团队文件</div>
              </template>
            </v-checkbox>
            <div style="width: 60px"></div>
          </div>
          <div style="width: 586px;height: 1px;background: rgba(229, 229, 229, 1);margin-top: 16px"></div>
          <div style="margin-left: 16px;display: flex;margin-top: 12px;">
            <v-checkbox
                    v-model="allowMembersSaveFiles"
                    color="#297aff"
                    hide-details
                    dense
            >
              <template v-slot:label>
                <div style="color: black;margin-left: 5px">允许团队文件协作者保存团队数据文件</div>
              </template>
            </v-checkbox>
            <div style="width: 60px"></div>
          </div>
          <div style="width: 586px;height: 1px;background: rgba(229, 229, 229, 1);margin-top: 16px"></div>
          <div style="margin-left: 16px;display: flex;margin-top: 12px;">
            <v-checkbox
                    v-model="allowMembersInviteOthers"
                    color="#297aff"
                    hide-details
                    dense
            >
              <template v-slot:label>
                <div style="color: black;margin-left: 5px">允许团队文件协作者邀请其他协作者</div>
              </template>
            </v-checkbox>
            <div style="width: 60px"></div>
          </div>
          <div style="margin-top:49px;text-align:right;">
            <v-btn @click="createTeamFolder" width="100" height="35" dark color="#1E3A8A">新建</v-btn>
          </div>
        </div>
      </v-card-text>
    </v-card>


    <v-dialog v-model="oldFolderCloseDialogShow" persistent max-width="540">
      <v-card>
        <v-card-title class="tipsDialog-title">
          温馨提示
          <v-spacer></v-spacer>
          <p @click="oldFolderCloseDialogShow = false" class="tipsDialog-close iconfontFamily">&#xe60d;</p>
        </v-card-title>
        <v-card-text class="tipsDialog-mainArea">
          <div style="display:flex;align-items:center">
            <p class="tipsDialog-mainArea-icon iconfontFamily">&#xe627;</p>
            <p class="tipsDialog-mainArea-text">新建文件会失去当前未保存内容，是否继续？</p>
          </div>
          <div class="tipsDialog-mainArea-btnLine">
            <v-btn @click="oldFolderCloseDialogShow = false" width="100" height="35" color="#F5F5F5">取消</v-btn>
            <v-btn @click="oldFolderCloseOK" width="100" height="35" dark color="#1E3A8A" style="margin-left:50px;">确定</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-dialog>
</template>

<script>
export default {
  name: "CreateGlobeOperationFolder",
  props:["dialogShow"],
  data(){
    return{

      folderName:"",
      folderTypeSelect:0,
      teamFileSelect:0,
      allowMembersExportFiles:true,
      allowMembersSaveFiles:true,
      allowMembersInviteOthers:true,
      errorShow:false,
      errorText:"",

      //离开旧文件夹弹窗
      oldFolderCloseDialogShow:false,


    }

  },
  methods:{
    closeDialog(){
      this.$emit("closeDialog","")
    },


    //创建文件夹
    createFolder(){
      if(this.folderName.length > 30){
        this.errorText = "文件名超出30字"
        this.errorShow = true;
      }
      else if(this.folderName.trim().length === 0){
        this.errorText = "文件名不能为空"
        this.errorShow = true;
      }
      else{
        if(this.$store.state.globeQuitShowDialog){
          this.oldFolderCloseDialogShow = true;
        }
        else{
          this.$axios({
            method:"post",
            url:"/authorApi/z-geo-file/newFile",
            params:{
              fileName:this.folderName,
              isTeamFile:0,
              teamReadonly:0,
              teamExport:1,
              teamSave:1,
              teamInvite:0,
            }
          }).then((resultData)=>{
            resultData = resultData.data;
            console.log(resultData)
            if(resultData.status === 200){
              this.$emit("createFolderOk",resultData.data)
            }
            else if(resultData.status === 308){
              this.errorText = "已存在同名文件"
              this.errorShow = true;
            }
            else{
              console.log(resultData.status + resultData.message);
            }
          }).catch((err)=>{
            console.log(err);
          });
        }



      }
    },
    createTeamFolder(){
      if(this.folderName.trim().length === 0){
        this.errorText = "文件名不能为空"
        this.errorShow = true;
      }else if(this.folderName.length > 30){
        this.errorText = "文件名超出30字"
        this.errorShow = true;
      } else{
        if(this.$store.state.globeQuitShowDialog){
          this.oldFolderCloseDialogShow = true;
        }
        else{
          this.$axios({
            method:"post",
            url:"/authorApi/z-geo-file/newFile",
            params:{
              fileName:this.folderName,
              isTeamFile:1,
              teamReadonly:this.teamFileSelect,
              teamExport:this.allowMembersExportFiles ? 1 : 0,
              teamSave:this.allowMembersSaveFiles ? 1 : 0,
              teamInvite:this.allowMembersInviteOthers ? 1 : 0,
            }
          }).then((resultData)=>{
            resultData = resultData.data;
            console.log(resultData)
            if(resultData.status === 200){
              this.$emit("createFolderOk",resultData.data)
            }
            else if(resultData.status === 308){
              this.errorText = "已存在同名团队文件"
              this.errorShow = true;
            }
            else{
              console.log(resultData.status + resultData.message);
            }
          }).catch((err)=>{
            console.log(err);
          });
        }
      }
    },
    oldFolderCloseOK: function () {
      this.oldFolderCloseDialogShow = false;
      let data = new FormData()
      if (this.folderTypeSelect === 0) {
        data.append('fileName', this.folderName)
        data.append('isTeamFile', 0)
        data.append('teamReadonly', 0)
        data.append('teamExport', 1)
        data.append('teamSave', 1)
        data.append('teamInvite', 0)
      } else {
        data.append('fileName', this.folderName)
        data.append('isTeamFile', 1)
        data.append('teamReadonly', this.teamFileSelect)
        data.append('teamExport', this.allowMembersExportFiles ? 1 : 0)
        data.append('teamSave', this.allowMembersSaveFiles ? 1 : 0)
        data.append('teamInvite', this.allowMembersInviteOthers ? 1 : 0)
      }

      this.$axios.post('/authorApi/z-geo-file/newFile',data).then((resultData) => {
        resultData = resultData.data;
        console.log(resultData)
        if (resultData.status === 200) {
          this.$emit("createFolderOk", resultData.data)
        } else if (resultData.status === 308) {
          if(this.folderTypeSelect === 0)
            this.errorText = "已存在同名文件"
          else
            this.errorText = "已存在同名团队文件"
          this.errorShow = true;
        } else {
          console.log(resultData.status + resultData.message);
        }
      }).catch((err) => {
        console.log(err);
      });
    },



  }

}
</script>

<style scoped>

</style>
